import React, { Component } from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import trLocale from '@fullcalendar/core/locales/tr';
import interactionPlugin from "@fullcalendar/interaction";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import BoardManagementNote from "./BoardManagementNote";
class BoardManagementCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            currentEvent: {
                id: null,
                topic: "",
                start: "",
                members: ""
            },
            isFormVisible: false,
            isConfirmationModalVisible: false,
        };
        this.calendarRef = React.createRef();
    }
    handleDateClick = () => {
        this.setState({
            isFormVisible: true,
            isConfirmationModalVisible: false,
        });
    }
    handleEventClick = (info) => {
        this.setState({
            currentEvent: info.event.toPlainObject(),
            isFormVisible: true,
            isConfirmationModalVisible: false,
        });
    };
    render() {
        const { events, currentEvent, isFormVisible } = this.state;

        return (
            <div className="App">
                <FullCalendar
                    defaultView="dayGridMonth"
                    ref={this.calendarRef}
                    header={{
                        left: "prev,next",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    themeSystem="simple-silver"
                    plugins={[dayGridPlugin, interactionPlugin]}
                    locale={trLocale}
                    events={events}
                    dateClick={this.handleDateClick}
                    eventClick={this.handleEventClick}
                    eventContent={(arg) => {
                        return (
                            <div style={{ backgroundColor: '#dadada', border: '1px solid #dadada' }}>
                                <button onClick={() => this.setState({ isFormVisible: false, isConfirmationModalVisible: true })} style={{ background: 'red', left: '88px', top: '-11px', padding: '5px', opacity: '0.6' }} className="Btn btn-sm btn-icon"><strong>X</strong></button>
                                <p style={{ color: 'black' }}>{arg.event.extendedProps.topic}</p>
                                <p style={{ color: 'black' }}>{arg.event.start}</p>
                                <p style={{ color: 'black' }}>{arg.event.extendedProps.members}</p>
                            </div>
                        );
                    }}
                />
                <Modal isOpen={isFormVisible} size="md" className="ust">
                    <ModalHeader toggle={() => this.setState({ isFormVisible: false })}>Yeni Toplantı</ModalHeader>
                    <ModalBody>
                        <BoardManagementNote
                            onSave={this.saveEvent}
                            onCancel={() => this.setState({ isFormVisible: false })}
                            currentEvent={currentEvent}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
export default BoardManagementCalender;


// WEBPACK FOOTER //
// ./src/page/agenda/boardManagementCalendar.js